
export default () => ({
    idPrescription : '',
    idOrder: '',
    isUpdate: false,
    surveyCount: 0,
    totalSurveys: 15,
})